import { createSlice } from '@reduxjs/toolkit';
import { DateTime } from '../../lib/date_formatting';

const initialState = {
    currentStep: 0,
    previousSteps: [],
    dataLoaded: false,
    data: {
        organization: {
            id: null,
            name: null,
            core_activity: null,
            main_goals: [],
        },
        community: {
            name: null,
            pfp: null,
            banner: null,
            social_networks: [],
            timezone: DateTime.local().zone.ianaName,
        },
        collection: {
            name: null,
            pfp: null,
            banner: null,
            tradeable: true,
            primary_sale_starts_at: DateTime.now().toISO(),
            primary_sale_ends_at: DateTime.now().plus({ years: 2 }).toISO(),
        },
        firstCollectible: {
            name_en: null,
            scarcityType: null,
            image: null,
            video: null,
            max_supply: null,
            distribution_channel: null,
            start_price: null,
        },
        path: {
            name_en: null,
            background: null,
            description_en: null,
            starts_at: DateTime.now().toISO(),
        },
        quest: {
            name_en: null,
            templateId: null,
            action_description_en: null,
            questTemplate: {
                starts_at: DateTime.now().toISO(),
                quest_steps_attributes: [
                    {
                        difficulty: 'common',
                        xp_on_completion: 1,
                        target_actions_count: 1,
                    },
                ],
            },
        },
    },
};

export const onboardingSlice = createSlice({
    name: 'onboarding',
    initialState,
    reducers: {
        goToNextStep: (state) => ({
            ...state,
            currentStep: state.currentStep + 1,
            previousSteps: [...state.previousSteps, state.currentStep],
        }),
        goToPreviousStep: (state) => ({
            ...state,
            currentStep: state.previousSteps[state.previousSteps.length - 1],
            previousSteps: state.previousSteps.slice(0, -1),
        }),
        goToNextStage: (state, action) => ({
            ...state,
            currentStep: state.currentStep + action.payload.stepsToAdd,
            previousSteps: [...state.previousSteps, state.currentStep],
        }),
        moveUpToStep: (state, action) => ({
            ...state,
            currentStep: state.currentStep + action.payload.stepsToAdd,
            previousSteps: [...Array(action.payload.stepsToAdd).keys()],
        }),
        saveCurrentStepData: (state, action) => {
            const newData = {
                ...state.data,
                [action.payload.dataToUpdate]: {
                    ...state[action.payload.dataToUpdate],
                    ...action.payload.data,
                },
            };

            return {
                ...state,
                data: newData,
            };
        },
        setDataLoaded: (state) => ({
            ...state,
            dataLoaded: true,
        }),
    },
});

export const { goToNextStep, goToPreviousStep, saveCurrentStepData, goToNextStage, moveUpToStep, setDataLoaded } =
    onboardingSlice.actions;

export default onboardingSlice.reducer;
